import { Routes, Route } from 'react-router-dom'

import HashScrollOnNav from './components/HashScrollOnNav'
import Home from './views/home'
import Services from './views/services'
import BeforeAfterGallery from './views/before-after-gallery'
import RequestAFreeQuote from './views/request-a-free-quote'
import Contact from './views/contact'
import About from './views/about'
import NotFound from './views/not-found'

export default function App() {
  return (
    <>
      <HashScrollOnNav />
      <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/services" element={<Services />} />
      <Route path="/before-after-gallery" element={<BeforeAfterGallery />} />
      <Route path="/request-a-free-quote" element={<RequestAFreeQuote />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/about" element={<About />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
    </>
  )
}
